// 合并所有reducer 并且返回
import { combineReducers } from 'redux'
import { personalCenter } from './personalCenter'
import { teamReducer } from './teamRedux'

export default combineReducers({
  personalCenter,
  teamReducer
})
